import React from 'react';
import classNames from 'classnames';

import Truncate from 'react-truncate';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';
import { formatDate } from '../../../../helpers/dates';
import {
  WysiwygField,
  CoreLink,
  AngledSquare,
} from '../../../../components';

import './style.scss';


const NodeNewsTeaser = ({ id, entity, className }) => {
  const classes = classNames(className, 'mb-6');

  const day = formatDate(entity.getIn(['created', 0, 'value']), 'dd')
  const month = formatDate(entity.getIn(['created', 0, 'value']), 'MMM');

  return (
    <article typeof="schema:WebPage" className={classes}>
      <div className="NodeNewsTeaser News teaser">
        <CoreLink to={entity.getIn(['paths', DEFAULT_LANGUAGE])} className="overlapping-link">
          <div>
            <div className="NodeNewsTeaser__image">
              <Image
                alt={entity.getIn(['title', 0, 'value'])}
                src={{
                  0: entity.getIn(['field_image', 0, 'styles', 'teaser_image']),
                  768: entity.getIn(['field_image', 0, 'styles', 'large_teaser_image']),
                }}
                includeWebP
              />
              <AngledSquare size="60px">
                <div className="NodeNewsTeaser__date">
                  <div className="NodeNewsTeaser__date__day">{day}</div>
                  <div className="NodeNewsTeaser__date__month">{month}</div>
                </div>
              </AngledSquare>
            </div>

            <h3 className="NodeNewsTeaser__title">
              <div>
                <Truncate lines={2} ellipsis="..." trimWhitespace>
                  {entity.getIn(['title', 0, 'value'])}
                </Truncate>
              </div>
            </h3>
            <div className="NodeNewsTeaser__body">
              <Truncate lines={4} ellipsis="..." trimWhitespace>
                <WysiwygField
                  property="schema:text"
                  className="NodeNewsTeaser__body"
                  html={entity.getIn(['body', 0, 'summary'], entity.getIn(['body', 0, 'processed']))}
                />
              </Truncate>
            </div>
          </div>
        </CoreLink>
      </div>
    </article>
  );
};

export default NodeNewsTeaser;
